import styled from 'styled-components';

export const Wrapper = styled.div`
    & > *:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const ResendEmailWrapper = styled.div`
    display: flex;
    justify-content: center;
`;
